import { useAuth0 } from "@auth0/auth0-react";
import { Spin, message } from "antd";
import React, { useEffect } from "react";
import WebsiteLogo from "../../components/RegistrationLeftBar/WebsiteLogo";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../Utils/isAuth";
import { signIn, fetchTwitterEmail } from "../../api";
const VerifyingSocialLogin = () => {
  const { user, getAccessTokenSilently, getIdTokenClaims, isLoading } = useAuth0();
  const navigate = useNavigate();
  const [userEmailTwitter, setUserEmailTwitter] = React.useState(null);
  const authDetails = useSelector((state) => state.auth);
  const sysUser = getUser();

  useEffect(() => {
    const processLogin = async () => {
      try {
        if (!user) return;

        let updatedUser = { ...user };
        const source = updatedUser?.sub?.split("|")[0];

        // Handle Twitter-specific logic
        if (source === "twitter") {
          try {
            const { data } = await fetchTwitterEmail(updatedUser?.sub);
            if (data?.email) {
              updatedUser.email = data?.email;
              
              if (updatedUser?.name) {
                const [firstName, lastName] = updatedUser?.name?.split(" ");
                updatedUser.given_name = firstName;
                updatedUser.family_name = lastName;
              }
            }
          } catch (error) {
            console.error("Error fetching Twitter email:", error);
          }
        }

        if (!updatedUser?.email) {
          return;
        }

        // Prepare sign-in body
        const body = {
          email: updatedUser.email,
          type: "Auth0",
          emailVerified: updatedUser.email_verified,
          firstName: updatedUser.given_name,
          lastName: updatedUser.family_name,
        };

        // Perform sign-in
        const { data } = await signIn(body);
        
        if (data?.token) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("user", JSON.stringify(data.userData));
          navigate("/");
        }
      } catch (error) {
        message.error(error?.response?.data?.message || "An error occurred during sign in");
      }
    };

    if (user && !isLoading) {
      processLogin();
    }
  }, [user, isLoading, navigate]);

  // useEffect(() => {
  //   if (user) {
  //     // fetchTwitterEmail
  //     console.log("USER:", user);
  //     const source = user?.sub?.split("|")[0];
  //     console.log("source", source);
  //     if (source === "twitter") {
  //       fetchTwitterEmail(user?.sub).then(({ data }) => {
  //         if (data?.email) {
  //           user.email = data?.email;
  //           const name = user?.name;
  //           if (name) {
  //             console.log("name", name);
  //             const [firstName, lastName] = name.split(" ");
  //             user.given_name = firstName;
  //             user.family_name = lastName;
  //           }
  //         }
  //       })
  //     }


  //     const body = {
  //       email: user.email,
  //       type: "Auth0",
  //       emailVerified: user.email_verified,
  //       firstName: user.given_name,
  //       lastName: user.family_name,
  //     };
  //     console.log("BODY", body);
  //     signIn(body).then(({ data }) => {
  //       if (data?.token) {
  //         localStorage.setItem("token", data?.token)
  //         localStorage.setItem("user", JSON.stringify(data?.userData))
  //         // navigate("/");
  //       }
  //     }).catch((err) => {
  //       message.error(err?.response?.data?.message)
  //     })
  //   }
  // }, [user, isLoading]);



  useEffect(() => {
    console.log("sysUser", sysUser, authDetails);
    if (authDetails.loginSuccess) {
      if (
        sysUser?.onboardingStepsDone?.email_token &&
        sysUser?.onboardingStepsDone?.uid
      ) {
        navigate(
          `/verify-email/${sysUser?.onboardingStepsDone?.uid}/${sysUser?.onboardingStepsDone?.email_token}`
        );
      } else if (sysUser) {
        if (sysUser.sub_type_of_account || sysUser.is_superuser) {
          if (sysUser.type_of_account === "FAC") {
            navigate("/");
            return;
          }
          navigate("/deals");
        } else {
          navigate("/onboarding/0");
        }
      } else {
        navigate("/registration");
      }
    } else {
      if (authDetails.loginFailed) {
        navigate("/registration");
      }
    }
  }, [authDetails, user, navigate]);

  return (
    <div className="verify-social-login-wrapper">
      <WebsiteLogo />
      <Spin
        spinning
        className="spining-verify"
        indicator={<LoadingOutlined className="indicator" />}
      />
      <div className="verify-txt">Verifying social account credentials....</div>
    </div>
  );
};

export default VerifyingSocialLogin;
